/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 口座の連携単位
 * @export
 * @enum {string}
 */

export const CardWalletableUnit = {
    single: 'SINGLE',
    group: 'GROUP',
    all: 'ALL'
} as const;

export type CardWalletableUnit = typeof CardWalletableUnit[keyof typeof CardWalletableUnit];



